export const I18NEXT_LANG = 'i18next-lang';
export const COOKIE_EXPIRE = 30;
